<template>
  <v-row justify="end" class="mr-0">
    <v-dialog persistent v-model="chooseFileDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{$t('upload.add')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-on:submit.prevent>
              <v-row>
                <v-col cols="12">
                  <v-file-input
                    v-model="file"
                    :label="$t('file.add')"
                    :rules="rules.required_file"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>{{$t('required_fields')}}</small>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="blue darken-1" text :disabled="loading" @click="closeDialog">{{$t('close')}}</v-btn>
          <v-btn color="blue darken-1" text :loading="loading" :disabled="loading" @click="add">{{$t('add')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!---------------------------------- Snackbar  ----------------------------------------->
    <v-snackbar
      v-model="snackbar.show"
      :bottom=true
      :color="snackbar.color"
      :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <v-btn dark text @click="snackbar.show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
  import axios from 'axios';
  export default {
    props: {
      chooseFileDialog: false,
      api: ''
    },
    name: "Excel",
    data() {
      return {
        file: null,
        loading: false,
        rules: {
          required_file: [
            v => this.file !== null && this.file !== undefined && (this.file.name.split('.')[1] === 'xlsx' || this.file.name.split('.')[1] === 'xls') || this.$t('excel.file_validation'),
          ],
        },
        snackbar: {
          color: 'success',
          show: false,
          text: '',
          timeout: 3000,
        },
      }
    },
    methods: {
      add(){
        if (!this.$refs.form.validate()) {
          this.snackbar.color = 'error';
          this.snackbar.text = this.$t('snackbar_required');
          this.snackbar.show = true;
          return;
        };
        this.loading = true;
        let formData = new FormData();
        formData.append('file', this.file);
        axios.post('api/'+this.api, formData).then(response => {
          this.snackbar.color = 'success'
          this.snackbar.text = this.$t('add_success');
          this.snackbar.show = true;
          this.$refs.form.resetValidation()
          this.file = null;
          this.$emit('successEmit', response.data);
          this.loading = false;
          this.closeDialog();
        }).catch(error => {
          let message = error.response.data;
          this.loading = false;
          if(error.response.status == 401){
            this.loading = false
            this.$swal.fire({
              type: 'info',
              title: "Info",
              text: this.$t('validation.session'),
            })
            this.$router.push('/login')
          }else if(error.response.status == 429){
            this.$swal.fire({
              type: 'error',
              title: this.$t('validation.error'),
              text: message,
            })
          }else{
            this.$swal.fire({
              type: 'error',
              title: this.$t('validation.error'),
              text: error.text,
            })
          }
        })
      },
      closeDialog() {
        this.$refs.form.resetValidation()
        this.file = null;
        this.$emit('close')
      },
    },
  }
</script>

<style scoped/>
